import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Icon = ({ name }) => {
  const paths = {
    radio: <><path d="M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/><path d="M5 11a6 6 0 0 1 6 6M5 6a11 11 0 0 1 11 11"/></>,
    users: <><circle cx="9" cy="8" r="3"/><circle cx="17" cy="9" r="2"/><path d="M3 19c0-4 2-6 6-6s6 2 6 6M15 14c3 0 5 2 5 5"/></>,
    compass: <><circle cx="12" cy="12" r="9"/><path d="m15 9-2 4-4 2 2-4Z"/></>,
    file: <><path d="M6 3h8l4 4v14H6Z"/><path d="M14 3v5h5M9 13h6M9 17h6"/></>,
    shield: <><path d="M12 3 4 6v5c0 5 3.5 8.5 8 10 4.5-1.5 8-5 8-10V6Z"/><path d="m9 12 2 2 4-5"/></>,
    plus: <><circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/></>,
    mountain: <><path d="m3 19 6-11 3 5 2-3 7 9Z"/><path d="m7 12 2 2 2-2"/></>,
    info: <><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7h.01"/></>,
    like: <><path d="M7 10v11H3V10ZM7 19h10l3-8a2 2 0 0 0-2-3h-5l1-4-2-1-5 7Z"/></>,
    comment: <><path d="M4 5h16v12H8l-4 4Z"/><path d="M8 9h8M8 13h5"/></>,
    share: <><circle cx="18" cy="5" r="2"/><circle cx="6" cy="12" r="2"/><circle cx="18" cy="19" r="2"/><path d="m8 11 8-5M8 13l8 5"/></>,
    bookmark: <path d="M6 3h12v18l-6-4-6 4Z"/>,
    trend: <><path d="m4 16 5-5 4 3 7-8"/><path d="M15 6h5v5"/></>,
    match: <><circle cx="9" cy="8" r="3"/><path d="M3 19c0-4 2-6 6-6 2 0 3.5.5 4.5 1.5M18 12v6M15 15h6"/></>,
  };

  return <svg className="ui-icon" viewBox="0 0 24 24" aria-hidden="true">{paths[name]}</svg>;
};

const Sidebar = ({ currentUser }) => (
  <aside className="basecamp-sidebar">
    <div className="sidebar-identity">
      <div className="sidebar-badge"><Icon name="shield" /></div>
      <div>
        <strong>{currentUser ? 'Summit member' : 'The Basecamp'}</strong>
        <span>{currentUser ? 'CLIMBERLINK PROFILE' : 'CLIMBER NETWORK'}</span>
      </div>
    </div>

    <nav className="sidebar-nav" aria-label="Basecamp sections">
      <Link className="active" to="/"><Icon name="radio" /> Basecamp</Link>
      <Link to="/profiles"><Icon name="users" /> Network</Link>
      <Link to="/Trips"><Icon name="compass" /> Expeditions</Link>
      <Link to={currentUser ? '/profiles' : '/signup'}><Icon name="file" /> Climbing résumé</Link>
      <Link to="/profiles"><Icon name="shield" /> Safety center</Link>
    </nav>

    <Link className="plan-button" to="/Trips"><Icon name="plus" /> Plan expedition</Link>
  </aside>
);

const Composer = ({ currentUser }) => (
  <section className="composer panel">
    <img className="feed-avatar" src={currentUser?.photoURL || '/mtn.jpg'} alt="" />
    <div className="composer-body">
      <label htmlFor="basecamp-post" className="sr-only">Create a Basecamp post</label>
      <textarea id="basecamp-post" placeholder="Share recent route beta or log a summit..." />
      <div className="composer-actions">
        <div>
          <button type="button" className="soft-button"><Icon name="mountain" /> Log a summit</button>
          <button type="button" className="soft-button"><Icon name="info" /> Share beta</button>
        </div>
        {currentUser ? <button type="button" className="primary-button">Post update</button> : <Link to="/signup" className="primary-button">Join to post</Link>}
      </div>
    </div>
  </section>
);

const FeedPost = () => (
  <article className="feed-post panel">
    <header className="post-header">
      <img className="feed-avatar" src="/danielclimber.jpeg" alt="Daniel on a climb" />
      <div className="post-author">
        <strong>Daniel Morton</strong>
        <span>2H AGO <i>•</i> ROUTE BETA</span>
      </div>
      <button className="more-button" type="button" aria-label="More post actions">•••</button>
    </header>
    <p className="post-copy">
      Early-season conditions on <strong>Mount Rainier</strong> are shaping up well. Firm snow above 9,000 ft, light wind, and a clean boot pack through the upper mountain. Start early—the lower route is softening fast after noon.
    </p>
    <div className="post-image-wrap">
      <img src="/ranier.jpg" alt="Mount Rainier above an alpine meadow" />
      <div className="route-data"><span>14,411 FT</span><span>9,000 FT GAIN</span><span>PD+</span></div>
    </div>
    <footer className="post-actions">
      <div>
        <button type="button"><Icon name="like" /> 242</button>
        <button type="button"><Icon name="comment" /> 48</button>
        <button type="button"><Icon name="share" /> Share</button>
      </div>
      <button type="button"><Icon name="bookmark" /> Save beta</button>
    </footer>
  </article>
);

const ExpeditionPost = () => (
  <article className="expedition-update panel">
    <header className="post-header">
      <div className="initial-avatar">CL</div>
      <div className="post-author">
        <strong>Cascade Alpine Team</strong>
        <span>6H AGO <i>•</i> EXPEDITION LOG</span>
      </div>
      <span className="verified-pill"><Icon name="shield" /> VERIFIED GUIDE</span>
    </header>
    <blockquote>“Reached high camp at 16:00. Weather holding and the team is moving well. Summit push begins at 02:00.”</blockquote>
    <div className="expedition-gallery">
      <img src="/background.JPG" alt="Climber moving through high alpine terrain" />
      <div>
        <img src="/danielclimber.jpeg" alt="Climber during an expedition" />
        <div className="gallery-more">+3 PHOTOS</div>
      </div>
    </div>
  </article>
);

const RightRail = () => (
  <aside className="basecamp-rail">
    <section className="rail-card panel">
      <h2><Icon name="trend" /> Trending objectives</h2>
      <Link to="/Trips" className="trend-card rainier">
        <strong>Tahoma, WA</strong><span>32 CLIMBERS THIS WEEK</span>
      </Link>
      <Link to="/Trips" className="trend-card alpine">
        <strong>North Cascades</strong><span>18 TRIPS PLANNING</span>
      </Link>
      <Link className="rail-link" to="/Trips">View all objectives →</Link>
    </section>

    <section className="rail-card panel">
      <h2><Icon name="match" /> Partner matching</h2>
      <div className="partner-row"><img src="/danielclimber.jpeg" alt="" /><div><strong>Maya Sterling</strong><span>Alpine · Rainier</span></div><button type="button">+</button></div>
      <div className="partner-row"><img src="/mtn.jpg" alt="" /><div><strong>Erik Weiss</strong><span>Trad · 5.11c</span></div><button type="button">+</button></div>
      <Link className="rail-link" to="/profiles">Find your partner →</Link>
    </section>

    <section className="readiness-card">
      <span className="eyebrow">EXPEDITION READINESS</span>
      <h2>Your next summit starts here.</h2>
      <div className="meter-label"><span>Profile strength</span><strong>68%</strong></div>
      <div className="meter"><i style={{ width: '68%' }} /></div>
      <Link to="/signup">Complete your profile</Link>
    </section>
  </aside>
);

function HomePage() {
  const { currentUser } = useAuth();

  return (
    <div className="basecamp-layout">
      <Sidebar currentUser={currentUser} />
      <div className="basecamp-content">
        {!currentUser && (
          <section className="welcome-strip">
            <div><span className="eyebrow">THE PROFESSIONAL CLIMBING NETWORK</span><h1>Welcome to Basecamp.</h1><p>Find partners, share route intelligence, and build a climbing résumé that travels with you.</p></div>
            <Link to="/signup" className="primary-button">Create your profile</Link>
          </section>
        )}
        <div className="mobile-section-title"><span className="eyebrow">LIVE FROM THE MOUNTAINS</span><h1>Basecamp</h1></div>
        <Composer currentUser={currentUser} />
        <FeedPost />
        <ExpeditionPost />
      </div>
      <RightRail />
    </div>
  );
}

export default HomePage;
